import { Result } from "antd";
import { useAuth } from "../store/context/AuthContext";
import { hasPerm } from "../utilities/permission";

const PermissionRoute = ({ perm, children }) => {
  const { user } = useAuth();
  if (!user) return null;
  if (perm && !hasPerm(user, perm)) {
    return (
      <Result
        status="403"
        title="Хандах эрхгүй"
        subTitle="Танд энэ хуудсыг үзэх эрх байхгүй байна."
      />
    );
  }
  return children;
};

export default PermissionRoute;
